import React from 'react';

const Field = ({ label, children, half, error }) => (
  <div style={{
    marginBottom: 12,
    display: 'inline-block',
    width: half ? '48%' : '100%',
    marginRight: half ? '4%' : 0,
    verticalAlign: 'top'
  }}>
    <label style={{ display: 'block', fontSize: 11, color: error ? '#d32f2f' : '#666', marginBottom: 3, fontWeight: 500 }}>
      {label}{error ? ' *' : ''}
    </label>
    {children}
    {error && <div style={{ fontSize: 10, color: '#d32f2f', marginTop: 2 }}>{error}</div>}
  </div>
);

const Input = ({ value, onChange, placeholder, error }) => (
  <input
    type="number"
    value={value ?? ''}
    onChange={e => onChange(e.target.value === '' ? null : Number(e.target.value))}
    onKeyDown={e => {
      if (e.shiftKey && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
        e.preventDefault();
        const step = parseFloat(e.target.step) || 1;
        const current = parseFloat(e.target.value) || 0;
        const delta = (e.key === 'ArrowUp' ? 1 : -1) * step * 10;
        onChange(Math.round((current + delta) * 1e6) / 1e6);
      }
    }}
    placeholder={placeholder}
    step="0.01"
    style={{
      width: '100%', padding: '6px 8px',
      border: `1px solid ${error ? '#d32f2f' : '#ddd'}`,
      borderRadius: 3, fontSize: 13, boxSizing: 'border-box'
    }}
  />
);

const GuidesTab = ({ formData, onChange, validationErrors }) => {
  const errors = validationErrors || {};

  return (
    <div>
      <h4 style={{ margin: '0 0 12px', fontSize: 14, color: '#333' }}>Face Placement</h4>
      <p style={{ fontSize: 10, color: '#999', margin: '-8px 0 8px' }}>
        Values are % of canvas (e.g. 0.25 = 25%). These control where the student's face is positioned in the final output.
      </p>

      <Field label="Eyes Y (%)" half error={errors.eyes_y}>
        <Input value={formData.eyes_y} onChange={v => onChange({ eyes_y: v })} placeholder="0.0–1.0" error={!!errors.eyes_y} />
      </Field>
      <Field label="Face Height (%)" half error={errors.face_height}>
        <Input value={formData.face_height} onChange={v => onChange({ face_height: v })} placeholder="0.0–1.0" error={!!errors.face_height} />
      </Field>
      <Field label="Center X (%)" half error={errors.center_x}>
        <Input value={formData.center_x} onChange={v => onChange({ center_x: v })} placeholder="0.0–1.0" error={!!errors.center_x} />
      </Field>
      <Field label="Rotation (deg)" half>
        <Input value={formData.rotation} onChange={v => onChange({ rotation: v })} placeholder="0" />
      </Field>
    </div>
  );
};

export default GuidesTab;
